import { type LucideIcon } from 'lucide-react'
import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type EmptyStateProps = {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
  /** `error` swaps the palette to destructive without changing the layout. */
  tone?: 'neutral' | 'error'
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  tone = 'neutral',
}: EmptyStateProps): ReactNode {
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}
    >
      {Icon ? (
        <span
          aria-hidden="true"
          className={cn(
            'mb-3 flex size-10 items-center justify-center rounded-full',
            tone === 'error' ? 'bg-destructive-subtle text-destructive' : 'bg-muted text-muted-foreground',
          )}
        >
          <Icon className="size-5" />
        </span>
      ) : null}
      <p className="text-body font-medium text-foreground">{title}</p>
      {description ? (
        <p className="mt-1 max-w-sm text-body-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
